const HEX_COLOR = /^#([\da-f]{3}|[\da-f]{6})$/i;
const UNPREFIXED_HEX_COLOR = /^([\da-f]{3}|[\da-f]{6})$/i;

export function normalizeAccentColor(color: string) {
  const trimmedColor = color.trim();
  return UNPREFIXED_HEX_COLOR.test(trimmedColor)
    ? `#${trimmedColor}`
    : trimmedColor;
}

function parseHexColor(color: string) {
  const match = HEX_COLOR.exec(normalizeAccentColor(color));
  if (!match) {
    return;
  }
  const [, value] = match;
  if (!value) {
    return;
  }
  const expanded =
    value.length === 3
      ? Array.from(value, (character) => `${character}${character}`).join("")
      : value;
  return [0, 2, 4].map((offset) =>
    Number.parseInt(expanded.slice(offset, offset + 2), 16)
  );
}

function relativeLuminance([red, green, blue]: number[]) {
  const [linearRed = 0, linearGreen = 0, linearBlue = 0] = [
    red,
    green,
    blue,
  ].map((channel = 0) => {
    const normalized = channel / 255;
    return normalized <= 0.040_45
      ? normalized / 12.92
      : ((normalized + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * linearRed + 0.7152 * linearGreen + 0.0722 * linearBlue;
}

export function getAccentContrast(color: string) {
  const parsed = parseHexColor(color);
  if (!parsed) {
    return;
  }
  const luminance = relativeLuminance(parsed);
  const blackContrast = (luminance + 0.05) / 0.05;
  const whiteContrast = 1.05 / (luminance + 0.05);
  return blackContrast >= whiteContrast ? "#000" : "#fff";
}
